const checkerboardCombination = {
  small: {
    noWarp: {
      swatchId: 4528,
      imageId: "d654e5668509163601ac61acab48d671"
    },
    bulge: {
      swatchId: 4529,
      imageId: "13f1cc6e82b81609ed0feb3cb2b1a4e3"
    },
    pinch: {
      swatchId: 4530,
      imageId: "6d61ab0d1668c5a259152636cd5baaba"
    },
    crazyWarp: {
      swatchId: 4531,
      imageId: "e57fb0a7adeb47e9d544a7f403e3c4d6"
    }
  },
  medium: {
    noWarp: {
      swatchId: 4524,
      imageId: "ee7bf382e6dbaff2a0ef846e39a8ee38"
    },
    bulge: {
      swatchId: 4525,
      imageId: "d89752adf46cecbd50df03f6e1ca3f20"
    },
    pinch: {
      swatchId: 4526,
      imageId: "26e6bd3705523eaeba0b765493e11bfd"
    },
    crazyWarp: {
      swatchId: 4527,
      imageId: "61f7b56a2d80b8289da4150315265c03"
    }
  },
  large: {
    noWarp: {
      swatchId: 4532,
      imageId: "ecc4edc194f30638c8fbdea560af11fb"
    },
    bulge: {
      swatchId: 4533,
      imageId: "b5d8915aeded3405da656cbb78534b88"
    },
    pinch: {
      swatchId: 4534,
      imageId: "e284279cb60b07fb7781375cf8f696ee"
    },
    crazyWarp: {
      swatchId: 4535,
      imageId: "f71e4018c6a09d51a02783c179972ca7"
    }
  }
};

const checkerboardSwatches = [
  4528, 4529, 4530, 4531, 4524, 4525,
  4526, 4527, 4532, 4533, 4534, 4535
]

export {
  checkerboardCombination,
  checkerboardSwatches
}
